<template>
  <div>
    <edit-applicant-address :value="address" :prefixLabel="prefixLabel"/>
    <div class="land-title">
      <LandTitleSearchResult
        :land-title-fetch-results="address.land_title"
        :application-id="application.loan.id"
        :applicant-id="applicantId"
      >
      </LandTitleSearchResult>
      <loading-icon-text-button
        class="md-primary md-sm"
        @click="search_land_title"
        icon="search"
        :loading="loading_search_land_title"
      >
        Search Land Title
      </loading-icon-text-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EditApplicantAddress from './EditApplicantAddress.vue';
import LandTitleSearchResult from '@/components/Search/LandTitleSearchResult';
import LoadingIconTextButton from "../LoadingIconTextButton";
import AlertDialog from '../Dialogs/AlertDialog.vue';
import ConfirmDialog from "../Dialogs/ConfirmDialog";

export default {
  components: {
    EditApplicantAddress,
    LandTitleSearchResult,
    LoadingIconTextButton,
    AlertDialog,
    ConfirmDialog,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    applicantId: {
      type: Number,
      required: true,
    },
    prefixLabel: {
      type: String,
      default: '',
    },
    landTitle: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading_search_land_title: null,
      investment_property_address: {
        id: null,
        land_title: null,
      },
    }
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      application: 'application',
      land_title_results: 'landTitleFetchResults',
    }),
    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    address: {
      get(){
        return this.value;
      },
      set(address){
        this.$emit('input', address);
      },
    }
  },
  methods: {
    async search_land_title() {
      try {
        if (this.address.land_title.length > 0) {
          const res = await this.showNotification(
            "Confirm",
            "This will request a new land title search and will incur an additional charge. Continue?",
            "Confirm",
            "Cancel"
          );
          if (!res) {
            return;
          }
        }
        this.loading_search_land_title = true;

        if (this.address == '' ||
          this.address == null ||
          this.address.street_number == '' ||
          this.address.street_name == '' ||
          this.address.state == '' ||
          this.address.post_code == ''
        ) {
          await this.showAlertDialog('Failed to search Land Title', 'Address field has not been filling up properly.');
          return;
        }

        // create or update application
        await this.$store.dispatch('save_application', this.application);

        // get applicant
        const applicant = this.application.applicants.find((applicant) => applicant.id = this.applicantId);
        // get investment property
        const investment_property = applicant.assets.find((asset) => {
          return asset.type === "Investment Property"
            && asset.address.full_address === this.address.full_address;
        });

        if (!investment_property?.address?.id) {
          await this.showAlertDialog('Failed to search Land Title', 'Please save application before requring land title.');
        } else {
          this.$set(this, "investment_property_address", investment_property.address);
          await this.send_land_title_search(this.investment_property_address.id);
        }

        return;
      } catch (error) {
        console.error(error);
        await this.showAlertDialog('Error', 'An error occurred while searching for land title.');
        return;
      } finally {
        if (!!this.investment_property_address?.id) {
          this.$set(this, 'address', this.investment_property_address);
          this.$set(this.address, 'land_title', this.investment_property_address.land_title);
        }
        this.loading_search_land_title = false;
      }
    },

    async send_land_title_search() {
      try {
        const result = await this.$store.dispatch(
          'request_land_title_by_investment_property', {
            "application_id": this.application.loan.id,
            "address_id": this.investment_property_address.id,
            "applicant_id": this.applicantId,
          }
        );

        if (result != true) {
          this.showAlertDialog('Failed to search Land Title', `The following error occurred: ${result}`);
        } else {
          // check type of return data
          if (Array.isArray(this.land_title_results)) {
            this.$set(this.investment_property_address, "land_title", this.land_title_results);
          } else if (this.land_title_results !== null && typeof this.land_title_results === 'object') {
            this.$set(this.investment_property_address, "land_title", [this.land_title_results]);
          }
        }
      } catch (error) {
        console.error(error);
      }
      return;
    },

    showNotification(title, message, confirmText, cancelText = null) {
      return this.$modal.show(ConfirmDialog, {
        title,
        message,
        confirmText,
        cancelText
      })
    },
    async showAlertDialog(title, message) {
      return await this.$modal.show(AlertDialog, {
        title: title,
        message: message,
      });
    },
  },
}
</script>
<style scoped lang="scss">
.land-title {
  padding-left: 18px;
  padding-right: 18px;
}
</style>